jQuery(document).ready(function() {
  jQuery('#MainOption1').attr('value', jQuery("#MainOption option:selected").text());
  jQuery( ".select1" ).change(function() {
    jQuery( "#select2 option" ).addClass('hide');
    jQuery( ".op" + jQuery( ".select1" ).val()).removeClass('hide');
    jQuery( "#select2 > option:eq(0)").removeClass('hide');
    jQuery( "#select2 > option:eq(0)").prop('selected', true);
    jQuery('.content-tab').addClass('hide');
    jQuery('#email-contact').addClass('hide');
    jQuery('#MainOption1').attr('value', jQuery("#MainOption option:selected").text());
  });
  
  jQuery( "#select2" ).change(function() {
    jQuery('.content-tab').addClass('hide');
    jQuery( "#" + jQuery( "#select2" ).val()).removeClass('hide');
    jQuery('#email-contact').addClass('hide');
    jQuery('#MainOption2').attr('value', jQuery("#select2 option:selected").text());
  });  
  
  jQuery( "#template" ).change(function() {
    jQuery('.img').addClass('hide');
    console.info(jQuery( "#template 2").attr('src'));
    jQuery( "#" + jQuery( "#template" ).val()).removeClass('hide');
  });  
  
  jQuery('.contact_form').click(function () {
      jQuery('#email-contact').removeClass('hide');
      jQuery('#email-contact')[0].scrollIntoView();
  });
});